<template>
  <div class="carteira-vacinacao-details">
    <page-header :title="title" />
    <page-section :group-label="$t('Carteira')">
      <v-row no-gutters>
        <v-col class="mb-4" cols="12">
          <field-section
            :value="pet.carteiraVacinacao"
            :is-restrict="$store.getters['pet/isRestrict']('carteiraVacinacao')"
          >
            <template #value>
              <div v-if="pet.carteiraVacinacao" class="mt-2 d-inline">
                <v-btn
                  link
                  tag="a"
                  target="_blank"
                  :href="
                    $store.state.vaccineDocumentsURL + pet.carteiraVacinacao
                  "
                  elevation="0"
                  small
                  color="blue lighten-1"
                  text
                >
                  <v-icon size="18" class="mr-1">mdi-open-in-new</v-icon>
                  {{ $t("visualizar") }}
                </v-btn>
              </div>
              <div v-else>
                <i class="text-caption grey--text text--darken-1">
                  {{ $t("nenhum_anexo") }}
                </i>
              </div>
            </template>
          </field-section>
        </v-col>
      </v-row>
    </page-section>
    <page-section :group-label="$t('Carteira_Convenio')">
      <v-row no-gutters>
        <v-col class="mb-4" cols="12">
          <field-section
            :value="pet.carteiraConvenio"
            :is-restrict="$store.getters['pet/isRestrict']('carteiraConvenio')"
          >
            <template #value>
              <div v-if="pet.carteiraConvenio" class="mt-2 d-inline">
                <v-btn
                  link
                  tag="a"
                  target="_blank"
                  :href="
                    $store.state.healthInsuranceDocumentsURL +
                    pet.carteiraConvenio
                  "
                  elevation="0"
                  small
                  color="blue lighten-1"
                  text
                >
                  <v-icon size="18" class="mr-1">mdi-open-in-new</v-icon>
                  {{ $t("visualizar") }}
                </v-btn>
              </div>
              <div v-else>
                <i class="text-caption grey--text text--darken-1">
                  {{ $t("nenhum_anexo") }}
                </i>
              </div>
            </template>
          </field-section>
        </v-col>
      </v-row>
    </page-section>
    <page-section :group-label="$t('Carteira_Doador')">
      <v-row no-gutters>
        <v-col class="mb-4" cols="12">
          <field-section
            :value="pet.carteiraDoador"
            :is-restrict="$store.getters['pet/isRestrict']('carteiraDoador')"
          >
            <template #value>
              <div v-if="pet.carteiraDoador" class="mt-2 d-inline">
                <v-btn
                  link
                  tag="a"
                  target="_blank"
                  :href="$store.state.donorDocumentsURL + pet.carteiraDoador"
                  elevation="0"
                  small
                  color="blue lighten-1"
                  text
                >
                  <v-icon size="18" class="mr-1">mdi-open-in-new</v-icon>
                  {{ $t("visualizar") }}
                </v-btn>
              </div>
              <div v-else>
                <i class="text-caption grey--text text--darken-1">
                  {{ $t("nenhum_anexo") }}
                </i>
              </div>
            </template>
          </field-section>
        </v-col>
      </v-row>
    </page-section>
    <page-section :group-label="$t('Carteira_Link')">
      <v-row no-gutters>
        <v-col class="mb-4" cols="12">
          <field-section
            :value="pet.carteiraLink"
            :is-restrict="$store.getters['pet/isRestrict']('carteiraLink')"
          >
            <template #value>
              <div v-if="pet.carteiraLink" class="mt-2 d-inline">
                <v-btn
                  link
                  tag="a"
                  target="_blank"
                  :href="formatterURL(pet.carteiraLink)"
                  elevation="0"
                  small
                  color="blue lighten-1"
                  text
                >
                  <v-icon size="18" class="mr-1">mdi-open-in-new</v-icon>
                  {{ $t("visualizar") }}
                </v-btn>
              </div>
              <div v-else>
                <i class="text-caption grey--text text--darken-1">
                  {{ $t("nenhum_anexo") }}
                </i>
              </div>
            </template>
          </field-section>
        </v-col>
      </v-row>
    </page-section>
    <Form :title="title" :data="pet" />
  </div>
</template>

<script>
import i18next from "i18next";
import PageHeader from "@/components/headers/page-header";
import PageSection from "@/components/sections/page-section";
import FieldSection from "@/components/sections/field-section";
import Form from "./form";
export default {
  metaInfo: {
    titleTemplate: (i18next.t("Carteira_Vacinacao") || "") + " | %s",
  },
  components: { FieldSection, PageSection, PageHeader, Form },
  data: () => ({
    title: i18next.t("Carteira_Vacinacao"),
  }),
  computed: {
    pet() {
      return this.$store.state.pet.data || {};
    },
  },
  methods: {
    formatterURL(url) {
      return !/^http:\/\/|https:\/\//.test(url)
        ? "https://" + url.replace(/^http:\/\/|https:\/\//, "")
        : url;
    },
  },
};
</script>

<style scoped></style>
